import React, {useEffect, useState} from "react";
import * as AuthSession from 'expo-auth-session';
import {CodeChallengeMethod, TokenResponse} from 'expo-auth-session';
import * as WebBrowser from 'expo-web-browser';
import {AsyncStorage, Platform} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {authenticated, reduxReset} from '../../../actions/authActions';
import getConfig from "../../../environment";


const clientId = getConfig()?.oauth2ClientId;
const cliendIdIcpm = getConfig()?.oauth2ClientIdIcpm;
const authorizationEndpoint = getConfig()?.authorizationEndpoint;
const authorizationEndpointIcpm = getConfig()?.authorizationEndpointIcpm;
const authorizationEndpointSso = getConfig()?.authorizationEndpointSso;
const tokenEndpoint = getConfig()?.tokenEndpoint;
const tokenEndpointIcpm = getConfig()?.tokenEndpointIcpm;
const tokenEndpointSso = getConfig()?.tokenEndpointSso;
const logoutEndpoint = getConfig()?.logoutEndpoint;
const logoutEndpointIcpm = getConfig()?.logoutEndpointIcpm;
const webRedirectUrl = Platform.OS === 'web' ? window.location.href : 'https://auth.expo.io';


const useProxy = Platform.select({ web: false, default: true });

console.log('---- the platform is ----- ', Platform.OS);

/** these are needed while CIAM whitelisted endpoints contain /login or /logout in them
 * once whitelisted addresses are the same as site addresses
 * this should be replaced with commented out lines below
 */
const loginRedirectPathSso = '/login'
const loginRedirectPath = '/login';
const logoutRedirectPath = '/logout';
// const loginRedirectPath = '';
// const logoutRedirectPath = '';
const redirectUri = AuthSession.makeRedirectUri({
  native: webRedirectUrl,
  path: loginRedirectPath,
  useProxy,
});
const redirectUriIcpm = AuthSession.makeRedirectUri({
  native: webRedirectUrl,
  path: loginRedirectPath,
  useProxy,
});
const redirectUriSso = AuthSession.makeRedirectUri({
  native:webRedirectUrl,
  path: loginRedirectPathSso,
  useProxy
})
const logoutRedirectUri = AuthSession.makeRedirectUri({
  native: webRedirectUrl,
  path: logoutRedirectPath,
  useProxy,
})

const discovery = {
  authorizationEndpoint: authorizationEndpoint,
  tokenEndpoint: tokenEndpoint,
};

const discoveryIcpm = {
  authorizationEndpoint: authorizationEndpointIcpm,
  tokenEndpoint: tokenEndpointIcpm,
};
const discoverySSO = {
  authorizationEndpoint:authorizationEndpointSso ,
  tokenEndpoint: tokenEndpointSso
}
const tokenRequestConfig = {
  clientId: clientId,
  clientSecret: ''
};
const tokenRequestConfigIcpm = {
  clientId: cliendIdIcpm,
  clientSecret: '',
};

export const AUTH_CODE = 'auth_code';
export const AUTH_TOKEN = 'auth_token';

export default function AuthService(props:any) {

  const [authorizationCodeFlowInitiated, setAuthorizationCodeFlowInitiated] = useState(false);

  const isAuthenticated: boolean = useSelector((state:any) => state.authReducer.isAuthenticated);

  const dispatch = useDispatch();

  WebBrowser.maybeCompleteAuthSession();

  const startAuthorization = (setFlag:boolean) => {
    // console.log('inside start authorization');
    if (!authorizationCodeFlowInitiated) {
      if(setFlag) {
        setAuthorizationCodeFlowInitiated(true);
      }
      accessToken()
        .then(token => {
          if (token && !isAuthenticated) {
            // console.log("dispatching authenticated from startAuthorisation");
            authenticated(dispatch)
          }
        })
    }
  };

  useEffect(() => {
    startAuthorization(true);
  },[isAuthenticated]);

  return (null);

}


export async function authenticate() {
  return AuthService();
}

export async function isAuthenticated(): Promise<boolean> {
  if (await AsyncStorage.getItem(AUTH_CODE)) {
    return true
  }
  return false
}

export async function getAuthCode() {
  return await AsyncStorage.getItem(AUTH_CODE) || '';
}

export async function getAccessTokenFromAuth(authCode: string) {
  return AuthSession.exchangeCodeAsync(
    {
      ...tokenRequestConfig,
      redirectUri,
      code: authCode,
    },
    discovery,
  ).then(token => {
    AsyncStorage.setItem(AUTH_TOKEN, JSON.stringify(token));
    return token.accessToken
  });
}
export async function getAccessTokenFromAuthIcpm(authCode: string, isSso: boolean) {
  const discovery = !isSso ? discoveryIcpm : discoverySSO
  const redirectUri = !isSso ? redirectUriIcpm : redirectUriSso
  return AuthSession.exchangeCodeAsync(
      {
        ...tokenRequestConfigIcpm,
        redirectUri,
        code: authCode,
      },
      discovery,
  ).then(token => {
    AsyncStorage.setItem(AUTH_TOKEN, JSON.stringify(token));
    return token.accessToken
  });
}

export async function accessToken(): Promise<string | null> {
  // console.log("checking access token");
  if (await hasValidAccessToken()) {
    // console.log("token is valid");
    const token = await getToken();
    if (token) {
      // console.log(JSON.stringify(token));
      return token.accessToken
    }
    else {
      return null
    }
  }
  else if (await hasExpiredAccessToken()) {
    // console.log("token is expired");
    const token = await getToken();
    if (token) {
      // console.log('refresh token');
      // console.log(token.refreshToken);
      return AuthSession.refreshAsync(
        {
          ...tokenRequestConfig,
          refreshToken: token.refreshToken
        },
        discovery
      )
        .then(token => {
          AsyncStorage.setItem(AUTH_TOKEN, JSON.stringify(token));
          // console.log("token was refreshed");
          return token.accessToken
        })
        .catch(rejected => {
          // console.log("token could not be refreshed - expired?");
          return null;
        })
    }
    else {
      return null
    }
  }
  else {
     console.log("token is missing");
     return null
  }
}
export async function accessTokenIcpm(): Promise<string | null> {
  // console.log("checking access token");
  if (await hasValidAccessToken()) {
    // console.log("token is valid");
    const token = await getToken();
    if (token) {
      // console.log(JSON.stringify(token));
      return token.accessToken
    }
    else {
      return null
    }
  }
  else if (await hasExpiredAccessToken()) {
    // console.log("token is expired");
    const token = await getToken();
    if (token) {
      // console.log('refresh token');
      // console.log(token.refreshToken);
      return AuthSession.refreshAsync(
          {
            ...tokenRequestConfigIcpm,
            refreshToken: token.refreshToken
          },
          discovery
      )
          .then(token => {
            AsyncStorage.setItem(AUTH_TOKEN, JSON.stringify(token));
            // console.log("token was refreshed");
            console.log("Nas token",token.accessToken);
            return token.accessToken
          })
          .catch(rejected => {
            // console.log("token could not be refreshed - expired?");
            return null;
          })
    }
    else {
      return null
    }
  }
  else {
    return null
  }
}
export async function hasValidAccessToken(): Promise<boolean> {
  const token = await getToken();
  if (token) {
    return !token.shouldRefresh()
  }
  return false
}

export async function hasExpiredAccessToken(): Promise<boolean> {
  const token = await getToken();
  if (token) {
    return token.shouldRefresh()
  }
  return false
}

export async function logIn(dispatch:any): Promise<boolean> {
  const authReq = await AuthSession.loadAsync(
    {
      clientId: clientId,
      redirectUri,
      scopes: ['openid', 'profile', 'email', 'offline_access'],
    },
    discovery
  );
  if(authReq) {
    const auth = await authReq.promptAsync(discovery,{useProxy});
    if(auth) {
      if(auth.type === 'success') {
        console.log("--- authenticated")
        AsyncStorage.setItem(AUTH_CODE, JSON.stringify(auth.params.code))
        getAccessTokenFromAuth(auth.params.code)
          .then(token => {
            if (token) {
              console.log("--- dispatching authenticated from logIn");
              authenticated(dispatch)
            }
          })
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}
export async function loginICPM(dispatch:any, isSSO:boolean): Promise<boolean> {
  const discovery = !isSSO
      ? discoveryIcpm
      : discoverySSO
  const redirectUri = !isSSO ? redirectUriIcpm : redirectUriSso
  const authReq = await AuthSession.loadAsync(
      {
        clientId: cliendIdIcpm,
        redirectUri,
        scopes: ['openid','idp_information'],
        usePKCE: false,
        ...(isSSO && { extraParams: { kc_idp_hint :'bosch-azure-oidc'} }),
      }, discovery
  );
  if(authReq) {
    const auth = await authReq.promptAsync(discovery,{useProxy});
    if(auth) {
      console.log('The auth', auth)
      if(auth.type === 'success') {
        console.log("--- authenticated")
        AsyncStorage.setItem(AUTH_CODE, JSON.stringify(auth.params.code))
        getAccessTokenFromAuthIcpm(auth.params.code, isSSO )
            .then(token => {
              if (token) {
                console.log("--- dispatching authenticated from logIn", token);
                authenticated(dispatch)
              }
           })
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  } else {
    return false;
  }
}
export async function logoutIcpm(dispatch: any) {
  return getToken().then(token => {
    WebBrowser.openAuthSessionAsync(
        `${logoutEndpointIcpm}?id_token_hint=${token?.idToken}&post_logout_redirect_uri=${logoutRedirectUri}`, logoutRedirectUri
    ).then(() => {
      console.log('--- reseting redux');
      reduxReset(dispatch);
    });
    AsyncStorage.multiRemove([AUTH_CODE, AUTH_TOKEN]);
  })
}
export async function logout(dispatch: any) {
  return getToken().then(token => {
    WebBrowser.openAuthSessionAsync(
      `${logoutEndpoint}?id_token_hint=${token?.idToken}&post_logout_redirect_uri=${logoutRedirectUri}`, logoutRedirectUri
    ).then(() => {
      console.log('--- reseting redux');
      reduxReset(dispatch);
    });
    AsyncStorage.multiRemove([AUTH_CODE, AUTH_TOKEN]);
  })
}

export async function getToken(): Promise<TokenResponse | null> {
  const token = await AsyncStorage.getItem(AUTH_TOKEN);
  if (token) {
    const tokenResponse = new TokenResponse(JSON.parse(token));
    return tokenResponse
  }
  else {
    return null
  }
}
